<template>
    <div   v-on:keyup.esc="close" >
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >
                    <section class="modal-card-body  "  >
                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <HeaderDecorate :showLabNo=true :idlab="IDLABSelected.idlab" />
                    </section>
                </header>

                <section class="modal-card-body"  >

                    <DetailUsedPartFromRequestDataEachLab
                            :IDLABSelected ="IDLABSelected"/>




                    <!--               Head     -->
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-5"> Status </p>
                            </div>
                            <div class="level-item">
                                <p v-if="dataPARASpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataPARASpecLN.status.name }}  </p>
                                <p v-if="dataPARASpecLN.status.id >=5 && dataPARASpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataPARASpecLN.status.name }}  </p>
                                <p v-if="dataPARASpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataPARASpecLN.status.name }} </p>
                            </div>
                            <div class="level-item">
                                <b-icon icon="lock" type="is-danger"  v-if="dataPARASpecLN.status.id >=5 "  ></b-icon>
                                <b-icon icon="lock-open" type="is-success"  v-if="dataPARASpecLN.status.id < 5 "  ></b-icon>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5"> Assigned for </p>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5 has-text-black"> &nbsp; {{ dataPARASpecLN.assigned_to_user.name }}</p>
                            </div>
                            <div class="level-item" v-if="userIsAdmin && dataPARASpecLN.status.id !== 7 ">
                                <b-button size="is-medium"
                                          icon-left="minus-circle"  >
                                    Disable
                                </b-button>
                            </div>
                        </div>
                    </nav>



<!--------------------------------  Main   -->
                    <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{headerInfoPrepare}}
                                    </h1>
                                </div>


                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">
                                    <b-select placeholder="Template" v-model="dataTemplateSelectedPrepare"
                                              :disabled="!(userRoleFind(3) && dataPARASpecLN.status.id <5)">
                                        <option
                                                v-for="dataTemplate in myTemplate"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_prepare')"
                                              :disabled="!(userRoleFind(3) && dataPARASpecLN.status.id <5)"/>
                                </div>
                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffPARADatPrepareDatModel"
                                    id="editorDat_prepare"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataPARASpecLN.status.id <5 )"
                                    ref="editorDat_prepare"
                        />


                        <br>




                    </div>
<!--                BACT / PARA      -->
                    <div class="box" >

                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{ParasiteSelect}}
                                    </h1>
                                </div>


                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                 <b-button icon-left="plus" type="is-success" @click="addTemplateBact"
                                           :disabled="!((userRoleFind(4)  )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)"
                                 >  Add </b-button>
                                </div>
                            </div>
                        </nav>
<!--                        :key="dataBact.idbact_uuid"-->

                        <div  v-for="(dataBact,index) in dataPARASpecLN.data_bact"  :key="dataBact.idbact_uuid"  class="box" style="margin-top: 50px">

                            <Each_Parasite
                                    :enable="dataPARASpecLN.status.id <5"
                                    :data_bact="dataBact"
                                    :index ="index+1"
                                    @delete_idbact_uuid="delete_idbact_uuid"
                            />

                        </div>





                    </div>

<!-------------          finding and contents       -->
                    <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{findingAndContent}}
                                    </h1>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">

                                    <b-select placeholder="Template" v-model="dataTemplateSelectedCt"  :disabled="!((userRoleFind(4)||userRoleFind(5) )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)">
                                        <option
                                                v-for="dataTemplate in myTemplate"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>


                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_ct')"
                                              :disabled="!((userRoleFind(4)||userRoleFind(5) )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)"/>
                                </div>
                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffPARADatCtDatModel"
                                    id="editorDat_ct"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataPARASpecLN.status.id <5 )"
                                    ref="editorDat_ct"
                        />
                    </div>

 <!--          images  ----------------------------->
                    <div class="box">
                        <nav class="level">
                            <h1 class="title" style="color: #167df0">
                                <b-icon  icon="camera-image"  size="is-small"></b-icon>
                                Add Images
                            </h1>
                        </nav>
                        <nav class="level">
                            <b-tooltip label="Attach Image"  position="is-right">
                                <b-button
                                        icon-right="paperclip"
                                        type="is-success"
                                        @click="addImageAttach"
                                        :disabled="!((userRoleFind(4)  )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)"
                                        >Add Images</b-button>
                            </b-tooltip>
                        </nav>
                        <hr>
                        <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataPARASpecLN.img.dat.length>0"
                                             :dataPassThruImageList="dataPassThruImageList"
                                             @deleteImage="deleteImage" />
                        <hr  v-if="dataPARASpecLN.img.dat.length>0">
                        <br>
                    </div>


 <!--         Dx Code  ------------------------->
                    <div class="box">
                        <nav class="level">
                            <h1 class="title" style="color: #167df0"> <b-icon
                                    icon="codepen"
                                    size="is-small">
                            </b-icon>  Classification of Diseases</h1>
                        </nav>
                        <nav class="level">
                            <b-tooltip label="Add More Disease Code"  position="is-right">
                                <b-button
                                        type="is-success"
                                        icon-right="plus"
                                        @click="addNewDiseaseCode"
                                        :disabled="!((userRoleFind(4)||userRoleFind(5) )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)"
                                />

                            </b-tooltip>
                        </nav>
                        <br>

                        <b-table
                                :data="isEmpty ? [] : dataPARASpecLN.diag_code.dat"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards>


                            <b-table-column   label="Chapter"  v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column   label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>

                            <b-table-column   label="Unclassified Descriptions" v-slot="props" >
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>


                            <b-table-column   label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>





                            <b-table-column   label="#" v-slot="props">
                                <b-button type="is-danger" icon-right="delete" @click="deleteLabDiseasecodeRecWithLabID(props.row.ID)" :disabled="!((userRoleFind(4)||userRoleFind(5) )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id)" />
                            </b-table-column>



                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                        </b-table>


                    </div>
                </section>









                <footer class="modal-card-foot">
                    <div class="container" style=" width: 100vw; margin-left: 10px;">

                        <nav class="level" style="width:100vw;">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-danger"
                                              icon-left="close"  @click="close"   >
                                        Close
                                    </b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning" icon-left="cloud-upload"   v-if="userRoleFind(3)&& dataPARASpecLN.status.id <5"   @click="updateData(3)"  > Save Prepare</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"   v-if="(userRoleFind(4)  )&& dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id "    @click="updateData(4)"  > Save Content to Draft</b-button>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"      v-if="(userRoleFind(4) ) && dataPARASpecLN.status.id <5 && dataPARASpecLN.assigned_to_user.id === user_id "   @click="updateData(5)"  > Save Content to Publish Incomplete</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"     v-if="(userRoleFind(4) ) && dataPARASpecLN.status.id <6 && dataPARASpecLN.assigned_to_user.id === user_id "   @click="updateData(6)"  > Save Content to Publish Complete</b-button>
                                </div>

                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                            </div>
                        </nav>
                    </div>
                </footer>


            </div>


            <UploadFiles  v-if="isModalUploadFiles"
                          :idlab=null
                          :plus=false
                          @close="closeAddImageAttach"
                          @closeWithData="closeAddImageAttachWithData"/>

            <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                               @close="closeSelectDiseaseCode"
                               @closeWithChange="closeSelectDiseaseCode_WithChange" />


        </b-modal>

    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import HeaderDecorate from "./DecorateComponents/HeaderDecorate";
    import globalconst from "../../mixins/globalconst";
    import Each_Parasite from "./Parasite/Each_Parasite";
    import {  genUUID  , getBaseURLAvartar ,  getBaseURLforBackEnd , getConfigAxios , LOCATE_ENDPOINT_UPDATEEACH_KINDLAB }  from '@/utils.js'
    // import {  genUUID  , getBaseURLAvartar    }  from '@/utils.js'
    import UploadFiles from "../UtilsComponents/UploadFiles"
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import SelectDiseaseCode from "./SelectDiseaseCode";
    import htmlToText from "html-to-text";
    import axios from "axios";
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";
    import DetailUsedPartFromRequestDataEachLab from "../UtilsComponents/DetailUsedPartFromRequestDataEachLab";


    export default {
        name: "EditDocLabPARA",
        props:{
            isComponentModalActive : Boolean,
            IDLABSelected: null
        },
        mounted(){
            // window.vm = this
            
        },
        components:{
            HeaderDecorate,
            Each_Parasite,
            UploadFiles,
            ThumbnailImageList,
            SelectDiseaseCode,
            DetailUsedPartFromRequestDataEachLab
        },
        mixins:[userRoleFind,globalconst,reloadMyJobsTray],
        computed: {
            ...mapState({
                OPDSelected: state => state.opd_target.opd_selected,
                user_id: state => state.master_data.user_id,
                userIsAdmin: state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                user_role: state => state.master_data.user_role,


                dataPARASpecLN : state => state.parasite.dataPARASpecLN,
                buffPARADatPrepareDat: state => state.parasite.buffPARADatPrepareDat,
                buffPARADatCtDat: state => state.parasite.buffPARADatCtDat,
                tmplatePARA: state => state.parasite.tmplatePARA,



                myTemplate: state => state.mytemplateTxt.myTemplate,


                access_token: state => state.master_data.access_token,
            }),

            
           
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataPARASpecLN.img.dat.map(dat => {
                    // console.log(dat)
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded:
                            dat.fresh ? `${getBaseURLAvartar()}/temp/${dat.file}` :   `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            },


            buffPARADatPrepareDatModel :{
                get: function () {
                    return this.buffPARADatPrepareDat
                },
                set: function (newValue) {
                    this.produceBuffPARADatPrepareDat(newValue)
                }
            },

            buffPARADatCtDatModel :{
                get: function () {
                    return this.buffPARADatCtDat
                },
                set: function (newValue) {
                    this.produceBuffPARADatCtDat(newValue)
                }
            },
            getTextFromCtHTML:function () {
                return  htmlToText.fromString(this.buffPARADatCtDatModel, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            getTextFromPrepareHTML:function () {
                return  htmlToText.fromString(this.buffPARADatPrepareDatModel, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },

        },
        methods:{
            ...mapMutations({
                setDataPARASpecLN : 'parasite/setDataPARASpecLN',
            }),
            ...mapActions({
                fetchPARAOLDDat: 'parasite/fetchPARAOLDDat',

                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
                produceBuffPARADatPrepareDat : 'parasite/produceBuffPARADatPrepareDat',
                produceBuffPARADatCtDat : 'parasite/produceBuffPARADatCtDat',

            }),

            addTemplate(editorTarget){





                if(editorTarget === "editorDat_ct"){

                    if(this.dataTemplateSelectedCt !== null) {
                        const datToEditor = this.myTemplate.find(member => member.id === this.dataTemplateSelectedCt)

                        this.$refs.editorDat_ct.quill.focus()
                        if (this.$refs.editorDat_ct.quill.getSelection().index !== null) {
                            this.$refs.editorDat_ct.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_ct.quill.getSelection().index, datToEditor.content_html);
                            this.$refs.editorDat_ct.quill.setSelection(this.$refs.editorDat_ct.quill.getSelection().index + datToEditor.content_txt.length)
                        }
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `please select some template`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }
                }






                if(editorTarget === "editorDat_prepare"){

                    if(this.dataTemplateSelectedPrepare!== null) {
                        const datToEditor = this.myTemplate.find(member => member.id === this.dataTemplateSelectedPrepare)
                        this.$refs.editorDat_prepare.quill.focus()
                        if(this.$refs.editorDat_prepare.quill.getSelection().index !== null) {
                            this.$refs.editorDat_prepare.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_prepare.quill.getSelection().index,  datToEditor.content_html);
                            this.$refs.editorDat_prepare.quill.setSelection(  this.$refs.editorDat_prepare.quill.getSelection().index + datToEditor.content_txt.length )
                        }
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `please select some template`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }

                }





            },


            closeSelectDiseaseCode_WithChange(dataToSave){
                this.dataPARASpecLN.diag_code.dat.push(dataToSave)
            },
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode = false
            },
            addNewDiseaseCode(){
                this.isModalSelectDiseaseCode = true
            },


            deleteLabDiseasecodeRecWithLabID(id){
                const member = this.dataPARASpecLN.diag_code.dat.find( member => member.ID === id)
                const memberIndex = this.dataPARASpecLN.diag_code.dat.indexOf(member)

                this.dataPARASpecLN.diag_code.dat.splice(memberIndex,1)

            },

            deleteImage(fileNameUploaded){
                const member = this.dataPARASpecLN.img.dat.find(member => member.file === fileNameUploaded  )
                const memberIndex = this.dataPARASpecLN.img.dat.indexOf(member)
                this.dataPARASpecLN.img.dat.splice(memberIndex,1)
            },
            closeAddImageAttachWithData(dat){
                if(dat.file){

                    const tmp = {
                        "file":   dat.fileNameUploaded,
                        "title":  dat.title,
                        "fresh": true
                    }
                    this.dataPARASpecLN.img.dat.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            closeAddImageAttach(){
                this.isModalUploadFiles = false
            },
            addImageAttach(){
                this.isModalUploadFiles = true
            },
            delete_idbact_uuid(_idbact_uuid){
                // console.log(payload)
                const  tmp =  this.dataPARASpecLN.data_bact.find(dat=>{
                    return dat.idbact_uuid == _idbact_uuid
                })


                const memberIndex =  this.dataPARASpecLN.data_bact.indexOf(tmp)
                this.dataPARASpecLN.data_bact.splice(memberIndex,1)

            },

            addTemplateBact(){
                // genUUID(12)
                // let  tmp = Object.assign( {} ,this.tmplateBact)
                var tmp = JSON.parse(JSON.stringify(this.tmplatePARA))
                tmp.idbact_uuid = genUUID(12)
                for(var i=0;i<tmp.drugs.length;i++){
                     tmp.drugs[i].iddrug_uuid  = genUUID(9)
                }

                this.dataPARASpecLN.data_bact.push( tmp )
            },
            loadOldDat(){
                this.isFullScreenSearching = true

                /* eslint-disable */
                const datTo = {
                    "ln": this.IDLABSelected.idlab,
                    "ip": this.clientIP
                }

                // console.log(JSON.stringify(datTo))
                //
                this.fetchPARAOLDDat(datTo)
                    .then((res)=>{
                 
                        // commit in state but don't know why 
                        // require push into state again
                        this.setDataPARASpecLN(res)  // fixed but don't  know why


                        this.dataTemplateSelectedCt = null
                        this.dataTemplateSelectedPrepare = null
                        this.isFullScreenSearching = false
                    })
            },

            checkDataValid(){


                // check  Parasite at least one
                if(this.dataPARASpecLN.data_bact.length === 0 ){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `Parasite Examination No information <b>  is empty  </b>`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return false
                }

                //  check Parasite exist in every obj
                for(var i =0;i<this.dataPARASpecLN.data_bact.length;i++){
                      if( this.dataPARASpecLN.data_bact[i].idbact === null){
                          this.$buefy.dialog.alert({
                              title: 'Error',
                              message: `Parasite Examination No. <b> ${i+1} </b> is empty <i>Parasite name</i> `,
                              type: 'is-danger',
                              hasIcon: true,
                              icon: 'times-circle',
                              iconPack: 'fa',
                              ariaRole: 'alertdialog',
                              ariaModal: true
                          })
                          return false
                      }
                }


                //  check length iddrug in every obj


                for(var j =0;j<this.dataPARASpecLN.data_bact.length;j++){
                    if( this.dataPARASpecLN.data_bact[j].drugs.length === 0 && this.dataPARASpecLN.data_bact[j].want_data_drugs){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Parasite Examination No. <b> ${j+1} </b>  No information for drug <b>(at least one data!)</b>  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }



                //  check result in iddrug in every obj

                    for (var k = 0; k < this.dataPARASpecLN.data_bact.length; k++) {

                       if( this.dataPARASpecLN.data_bact[k].want_data_drugs){
                           for (var k1 = 0; k1 < this.dataPARASpecLN.data_bact[k].drugs.length; k1++) {
                               if (this.dataPARASpecLN.data_bact[k].drugs[k1].idresult === null ) {
                                   this.$buefy.dialog.alert({
                                       title: 'Error',
                                       message: `Parasite Examination No. <b>${k + 1}</b>  for drug No. <b>${k1 + 1}</b>   is  <b>  empty </b>  `,
                                       type: 'is-danger',
                                       hasIcon: true,
                                       icon: 'times-circle',
                                       iconPack: 'fa',
                                       ariaRole: 'alertdialog',
                                       ariaModal: true
                                   })
                                   return false
                               }
                           }
                       }

                    }




                return true
            },

            updateData(idstatus){

                if(this.checkDataValid()) {
                    // console.log('ok')
                    


                    //  // update ICD10 Code
                    var arrIndex = []
                    var arrID_GRP_ICD10 = []
                    var arrID_ACCURATE = []
                    var arrUnclassifiedCode = []
                    var arrCommentTxt = []
                    //  clear null to empty string
                    for (var j = 0; j < this.dataPARASpecLN.diag_code.dat.length; j++) {

                        if (this.dataPARASpecLN.diag_code.dat[j].level5ID === null) {
                            this.dataPARASpecLN.diag_code.dat[j].level5ID = ""
                        }
                        if (this.dataPARASpecLN.diag_code.dat[j].level4ID === null) {
                            this.dataPARASpecLN.diag_code.dat[j].level4ID = ""
                        }
                        if (this.dataPARASpecLN.diag_code.dat[j].level3ID === null) {
                            this.dataPARASpecLN.diag_code.dat[j].level3ID = ""
                        }
                        if (this.dataPARASpecLN.diag_code.dat[j].level2ID === null) {
                            this.dataPARASpecLN.diag_code.dat[j].level2ID = ""
                        }
                        if (this.dataPARASpecLN.diag_code.dat[j].level1ID === null) {
                            this.dataPARASpecLN.diag_code.dat[j].level1ID = ""
                        }


                    }

                    for (var i = 0; i < this.dataPARASpecLN.diag_code.dat.length; i++) {

                        if (this.dataPARASpecLN.diag_code.dat[i].level5ID !== "") {
                            arrID_GRP_ICD10.push(this.dataPARASpecLN.diag_code.dat[i].level5ID)
                        } else if (this.dataPARASpecLN.diag_code.dat[i].level4ID !== "") {
                            arrID_GRP_ICD10.push(this.dataPARASpecLN.diag_code.dat[i].level4ID)
                        } else if (this.dataPARASpecLN.diag_code.dat[i].level3ID !== "") {
                            arrID_GRP_ICD10.push(this.dataPARASpecLN.diag_code.dat[i].level3ID)
                        } else if (this.dataPARASpecLN.diag_code.dat[i].level2ID !== "") {
                            arrID_GRP_ICD10.push(this.dataPARASpecLN.diag_code.dat[i].level2ID)
                        } else if (this.dataPARASpecLN.diag_code.dat[i].level1ID !== "") {
                            arrID_GRP_ICD10.push(this.dataPARASpecLN.diag_code.dat[i].level1ID)
                        } else {
                            arrID_GRP_ICD10.push(null)
                        }


                        arrIndex.push(this.dataPARASpecLN.diag_code.dat[i].ID)
                        arrID_ACCURATE.push(this.dataPARASpecLN.diag_code.dat[i].labDiseasecodeAccurateID)
                        arrUnclassifiedCode.push(this.dataPARASpecLN.diag_code.dat[i].unClassifiedCodes)
                        arrCommentTxt.push(this.dataPARASpecLN.diag_code.dat[i].comment)
                    }


                    //******************************************************************************************************
                    var arrImage = []
                    for (var k = 0; k < this.dataPARASpecLN.img.dat.length; k++) {
                        arrImage.push({
                            "file": this.dataPARASpecLN.img.dat[k].file,
                            "title": this.dataPARASpecLN.img.dat[k].title,
                            "fresh": this.dataPARASpecLN.img.dat[k].fresh
                        })
                    }


                    // console.log('ok')
                    //******************************************************************************************************
                    var arrData_bact = []  //  {"idbact_uuid": "","idbact": "", "name_bact": "",   "drugs": []}

                        //    { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  }
                        for (var v = 0; v < this.dataPARASpecLN.data_bact.length; v++) {

                            var tmpDrug = []
                            if (this.dataPARASpecLN.data_bact[v].want_data_drugs){
                                for (var v1 = 0; v1 < this.dataPARASpecLN.data_bact[v].drugs.length; v1++) {
                                    // IDDRUG IDRESULT  IDMIC_PREFIX  MIC_VAL  REMARK  SORT_ID IDDRUG_UUID
                                    tmpDrug.push({
                                        "iddrug": this.dataPARASpecLN.data_bact[v].drugs[v1].iddrug,
                                        "idresult": this.dataPARASpecLN.data_bact[v].drugs[v1].idresult,
                                        "idmic_prefix": this.dataPARASpecLN.data_bact[v].drugs[v1].idmic_prefix,
                                        "mic_val": this.dataPARASpecLN.data_bact[v].drugs[v1].mic_val,
                                        "remark": this.dataPARASpecLN.data_bact[v].drugs[v1].remark,
                                        "sort_id": v1, //this.dataPARASpecLN.data_bact[v].drugs[v1].sort_id,
                                        "iddrug_uuid": this.dataPARASpecLN.data_bact[v].drugs[v1].iddrug_uuid
                                    })
                                }


                            }

                            arrData_bact.push({
                                // "idbact_uuid": `${v}${this.dataPARASpecLN.data_bact[v].idbact_uuid}`,
                                "idbact_uuid": `${v}${genUUID(6)}`,
                                "idbact": this.dataPARASpecLN.data_bact[v].idbact,
                                "bact_remark": this.dataPARASpecLN.data_bact[v].bact_remark,
                                "id_lab_method" :  this.dataPARASpecLN.data_bact[v].id_lab_method == "" || this.dataPARASpecLN.data_bact[v].id_lab_method === null ? null :  this.dataPARASpecLN.data_bact[v].id_lab_method,
                                "id_lab_method_result":  this.dataPARASpecLN.data_bact[v].id_lab_method_result == "" || this.dataPARASpecLN.data_bact[v].id_lab_method_result == null ? null : this.dataPARASpecLN.data_bact[v].id_lab_method_result,
                                "remark_method":  this.dataPARASpecLN.data_bact[v].remark_method == "" || this.dataPARASpecLN.data_bact[v].remark_method == null  ? null : this.dataPARASpecLN.data_bact[v].remark_method ,
                                "drugs": tmpDrug
                            })
                        }









                    const datTo = {
                        "ln": this.IDLABSelected.idlab,
                        "ip": this.clientIP,
                        "status": idstatus,
                        "data": {
                            "dat_prepare": ((this.buffPARADatPrepareDatModel !== null) || (this.buffPARADatPrepareDatModel.length > 0)) ? Buffer.from(this.buffPARADatPrepareDatModel).toString('base64') : null,
                            "dat_prepare_txt": ((this.getTextFromPrepareHTML !== null) || (this.getTextFromPrepareHTML.length > 0)) ? Buffer.from(this.getTextFromPrepareHTML).toString('base64') : null,
                            "dat_ct": ((this.buffPARADatCtDatModel !== null) || (this.buffPARADatCtDatModel.length > 0)) ? Buffer.from(this.buffPARADatCtDatModel).toString('base64') : null,
                            "dat_ct_txt": ((this.getTextFromCtHTML !== null) || (this.getTextFromCtHTML.length > 0)) ? Buffer.from(this.getTextFromCtHTML).toString('base64') : null,
                            "lab_diseasecode_labid": {
                                "arrindex": arrIndex,
                                "arrid_grp_icd10": arrID_GRP_ICD10,
                                "arrid_accurate": arrID_ACCURATE,
                                "arrunclassifiedcode": arrUnclassifiedCode,
                                "arrcommenttxt": arrCommentTxt
                            },
                            "lab_img_path": arrImage,
                            // "data_bact": [
                            //                   {"idbact_uuid": "","idbact": "", "name_bact": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
                            //              ],
                            "data_bact": arrData_bact

                        }
                    }


                    console.log(JSON.stringify(datTo))
                    const vm = this
                    this.isFullScreenSearching = true
                    if ((this.IDLABSelected.kind).toUpperCase() === "PARASITE") {
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_UPDATEEACH_KINDLAB.PARASITE}`, datTo, getConfigAxios())
                            .then(() => {
                                vm.isFullScreenSearching = false
                                vm.$buefy.toast.open({
                                    message: 'Update data completely!',
                                    type: 'is-success'
                                })
                                vm.reloadMyJobsTray()
                                vm.loadOldDat()
                            })
                            .catch(err => {

                                this.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `${err}`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })


                                if ( (err.response && err.response.status === 401) || (err.response && err.response.status === 422 ) ) {
                                    vm.$router.push('/login')
                                }
                            })
                            .finally(() => {
                                vm.isFullScreenSearching = false
                            })
                    }


                }


            },
            close(){
                this.$emit('close')
            }
        },
        data(){
            return{
                // tmpDataBact : {},
                isFullScreenSearching : false,
                isFullScreen : true,
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ],

                modeThumbnailImageList : "edit",
                isModalUploadFiles : false,
                isModalSelectDiseaseCode : false,
                isEmpty : false,

                dataTemplateSelectedCt : null,
                dataTemplateSelectedPrepare : null,
            }
        },
        watch:{
            isComponentModalActive :{
                immediate : true,
                handler: function (val) {
                    if(val){
                        this.loadOldDat()
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>